import { render, staticRenderFns } from "./tjbg.vue?vue&type=template&id=b58f3ef2&scoped=true"
import script from "./tjbg.vue?vue&type=script&lang=js"
export * from "./tjbg.vue?vue&type=script&lang=js"
import style0 from "./tjbg.vue?vue&type=style&index=0&id=b58f3ef2&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58f3ef2",
  null
  
)

export default component.exports